import { render, staticRenderFns } from "./edgeworkConfigDialog.vue?vue&type=template&id=9b4d44d8&"
import script from "./edgeworkConfigDialog.vue?vue&type=script&lang=js&"
export * from "./edgeworkConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports